import styled from "@emotion/styled";
var Picture = /*#__PURE__*/ styled("picture", {
    target: "e1u6nqb10"
})("display:none;height:100%;width:100%;right:0;@media (min-width:calc(36rem + 1px)){display:block;}");
var Image = /*#__PURE__*/ styled("img", {
    target: "e1u6nqb11"
})("height:100%;");
export { Image, Picture };
